import React, { useContext, useEffect, useRef, useState } from 'react';
import { FuelReload } from '@frete.com/fuel-react';
import AppContext from '@context';
import useAmplitude from '@hooks/useAmplitude';
import useLoadJourneys from '@hooks/useLoadJourneys';
import useLoadProposals from '@hooks/useLoadProposals';
import { useTimeout } from '@hooks/useTimeout';
import { formatHour } from '@utils/formatters';

function ButtonReload() {
  const {
    state: {
      journeys: { all: journeys },
    },
  } = useContext(AppContext);
  const { amplitudeEvent } = useAmplitude();
  const { fetchJourneys } = useLoadJourneys('lazy');
  const { fetchProposals } = useLoadProposals();
  const [lastReload, setLastReload] = useState('');
  const addTimeout = useTimeout();
  const reloadRef = useRef<HTMLFuelReloadElement>(null);

  function handleReload() {
    amplitudeEvent('journey_list_retry_clicked', {
      source: 'em-andamento',
    });

    fetchProposals({ page: 1 });
    fetchJourneys({ page: 1 });
  }

  useEffect(() => {
    const now = new Date();

    setLastReload(formatHour(now.toISOString(), ':'));
  }, [journeys.isFetched]);

  return (
    <FuelReload
      onFocus={() => {
        addTimeout(() => {
          if (reloadRef.current) {
            reloadRef.current.blur();
          }
        }, 500);
      }}
      onClick={() => handleReload()}
      label={lastReload}
      ref={reloadRef}
      loading={journeys.isFetching}
    />
  );
}

export default ButtonReload;
